import Modal from '@/components/ui/Modal';
import { currencies } from '@/constants/currencies';
import { Provider1RateBasis } from '@/types/provider1';
import { formatDate } from '@/utils/dateOperators/formatDate';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faShield } from '@fortawesome/pro-regular-svg-icons/faShield';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from 'js-cookie';
import { useState } from "react";
const RateCancellationInfo = ({ rate, roomName, price, defaultOpen = false, withDescription = false }: { rate: Provider1RateBasis, roomName?: string, price?: string, defaultOpen?: boolean, withDescription?: boolean }) => {
    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => {
        setShowDetails((prev) => !prev)
    };
    const currency = Cookies.get('currency') || 'USD'
    return (
        <>
            <div className="relative ">
                {!rate?.withinCancellationDeadline ? (
                    <div className="flex text-left items-start flex-col">
                        <div className="grid w-full cursor-pointer grid-cols-[16px,_1fr,_auto] items-center gap-1 my-2">
                            <FontAwesomeIcon className="text-green-500" icon={faShield} />
                            <div onClick={(e) => {
                                e.stopPropagation()
                                toggleDetails()
                            }} className="flex gap-2 text-green-500 text-sm font-normal">
                                <span className="text-green-500 font-normal text-xs">Refundable</span>
                                {withDescription && rate.cancellationRules.length > 0 && !defaultOpen && <FontAwesomeIcon icon={faInfoCircle} />}
                            </div>
                            {price && <span className='text-lg font-bold text-gray-800'>{price}</span>}
                        </div>
                        {withDescription && <>

                            {(defaultOpen) && (
                                <div className="flex flex-col gap-1 text-xs text-gray-600 font-normal mt-2">
                                    {rate.cancellationRules.map((item) => (
                                        <div key={item.fromDate}>
                                            Cancellation {item.fromDate ? `from ${formatDate(item.fromDate, true)}` : ""} {item.toDate ? `until ${formatDate(item.toDate, true)}` : ""} will charge
                                            <span className="text-rose-500"> {currencies[currency]}{item.charge}</span>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>}
                    </div>
                ) : (
                    <div className="grid grid-cols-[16px,_1fr,_auto] w-full items-center gap-1 my-2">
                        <FontAwesomeIcon className="text-rose-500" icon={faShield} />
                        <div className="flex flex-col text-left text-neutral-700 text-sm font-normal">
                            <span className="text-rose-500 font-normal text-xs">Not Refundable</span>
                        </div>
                        {price && <span className='text-lg font-bold text-gray-800'>{price}</span>}
                    </div>
                )}

            </div>
            {showDetails && <Modal maxWidth='max-w-fit' title='Cancellation Policy' show={showDetails} onClose={() => setShowDetails(false)} identifier='cancellation-policy-modal'>
                <div className=''>
                    <span className='capitalize'>
                        {roomName} <span className='text-gray-600 text-sm'>({rate.boardType})</span>
                    </span>
                    <div className="grid w-full grid-cols-[16px,_1fr,_auto] items-center gap-1 my-2">
                        <FontAwesomeIcon className="text-green-500" icon={faShield} />
                        <div className="flex flex-col text-neutral-700 text-sm font-normal">
                            <span className="text-green-500 font-normal text-xs">Refundable</span>
                        </div>
                        {price && <span className='text-lg font-bold text-gray-800'>{price}</span>}
                    </div>
                    <div className="flex flex-col gap-1 text-sm text-gray-600 font-normal mt-2">
                        {rate.cancellationRules.map((item) => (
                            <div key={item.fromDate}>
                                Cancellation {item.fromDate ? `from ${formatDate(item.fromDate, true)}` : ""} {item.toDate ? `until ${formatDate(item.toDate, true)}` : ""} will charge
                                <span className="text-rose-500"> {currencies[currency]}{item.charge}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>}
        </>
    );
};

export default RateCancellationInfo;
